export const ATTENDANCE_MODEL_DATA = {
  'periodType-10': {
    id: -10,
    title: '全部',
    parted: '参与考勤成员：全部学生',
    time:
      '考勤时间：周一、二、三、四（07:30-20:30)，周五（07:30-17:00），周六、日（不用考勤）',
    timeSettingList: [
      {
        dayOfWeek: 1,
        schoolTime: '07:30',
        homeTime: '20:30'
      },
      {
        dayOfWeek: 2,
        schoolTime: '07:30',
        homeTime: '20:30'
      },
      {
        dayOfWeek: 3,
        schoolTime: '07:30',
        homeTime: '20:30'
      },
      {
        dayOfWeek: 4,
        schoolTime: '07:30',
        homeTime: '20:30'
      },
      {
        dayOfWeek: 5,
        schoolTime: '07:30',
        homeTime: '17:00'
      }
    ],
    device: '考勤设备：全部设备',
    face: ''
  },
  periodType10: {
    id: 10,
    title: '幼儿园',
    parted: '参与考勤成员：全部幼儿园学生',
    time:
      '考勤时间：周一、二、三、四（09:00-16:30)，周五（09:00-15:00），周六、日（不用考勤）',
    timeSettingList: [
      {
        dayOfWeek: 1,
        schoolTime: '09:00',
        homeTime: '16:30'
      },
      {
        dayOfWeek: 2,
        schoolTime: '09:00',
        homeTime: '16:30'
      },
      {
        dayOfWeek: 3,
        schoolTime: '09:00',
        homeTime: '16:30'
      },
      {
        dayOfWeek: 4,
        schoolTime: '09:00',
        homeTime: '16:30'
      },
      {
        dayOfWeek: 5,
        schoolTime: '09:00',
        homeTime: '15:00'
      }
    ],
    device: '考勤设备：全部设备',
    face: '家长刷脸考勤：开启'
  },
  periodType20: {
    id: 20,
    title: '小学',
    parted: '参与考勤成员：全部小学学生',
    time:
      '考勤时间：周一、二、三、四（08:00-16:40)，周五（08:00-16:00），周六、日（不用考勤）',
    timeSettingList: [
      {
        dayOfWeek: 1,
        schoolTime: '08:00',
        homeTime: '16:40'
      },
      {
        dayOfWeek: 2,
        schoolTime: '08:00',
        homeTime: '16:40'
      },
      {
        dayOfWeek: 3,
        schoolTime: '08:00',
        homeTime: '16:40'
      },
      {
        dayOfWeek: 4,
        schoolTime: '08:00',
        homeTime: '16:40'
      },
      {
        dayOfWeek: 5,
        schoolTime: '08:00',
        homeTime: '16:00'
      }
    ],
    device: '考勤设备：全部设备',
    face: '家长刷脸考勤：开启'
  },
  periodType30: {
    id: 30,
    title: '初中',
    parted: '参与考勤成员：全部初中学生',
    time:
      '考勤时间：周一、二、三、四（07:30-20:30)，周五（07:30-17:00），周六、日（不用考勤）',
    timeSettingList: [
      {
        dayOfWeek: 1,
        schoolTime: '07:30',
        homeTime: '20:30'
      },
      {
        dayOfWeek: 2,
        schoolTime: '07:30',
        homeTime: '20:30'
      },
      {
        dayOfWeek: 3,
        schoolTime: '07:30',
        homeTime: '20:30'
      },
      {
        dayOfWeek: 4,
        schoolTime: '07:30',
        homeTime: '20:30'
      },
      {
        dayOfWeek: 5,
        schoolTime: '07:30',
        homeTime: '17:00'
      }
    ],
    device: '考勤设备：全部设备',
    face: ''
  },
  periodType40: {
    id: 40,
    title: '高中',
    parted: '参与考勤成员：全部高中学生',
    time:
      '考勤时间：周一、二、三、四（07:00-22:00)，周五（07:00-17:30），周六、日（不用考勤）',
    timeSettingList: [
      {
        dayOfWeek: 1,
        schoolTime: '07:00',
        homeTime: '22:00'
      },
      {
        dayOfWeek: 2,
        schoolTime: '07:00',
        homeTime: '22:00'
      },
      {
        dayOfWeek: 3,
        schoolTime: '07:00',
        homeTime: '22:00'
      },
      {
        dayOfWeek: 4,
        schoolTime: '07:00',
        homeTime: '22:00'
      },
      {
        dayOfWeek: 5,
        schoolTime: '07:00',
        homeTime: '17:30'
      }
    ],
    device: '考勤设备：全部设备',
    face: ''
  }
}
